// extracted by mini-css-extract-plugin
export default {"comparisonTable":"cz_kr","contentTable":"cz_ks"};